import Fetcher from "../fetcher/Fetcher";

const PeraApi = new Fetcher({
  baseUrl: "https://api.perawallet.app/v1"
});

export default PeraApi;
